import { render, staticRenderFns } from "./newsContentEditor.vue?vue&type=template&id=657149ed&scoped=true&"
import script from "./newsContentEditor.vue?vue&type=script&lang=js&"
export * from "./newsContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./newsContentEditor.vue?vue&type=style&index=0&id=657149ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657149ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VImg,VSheet,VTextarea})
